"use client";

import { Modal, ModalFuncProps } from 'antd';
import { ReactNode } from 'react';

// 全局 modal 实例
let globalModalInstance: ReturnType<typeof Modal.useModal>[0] | null = null;
let globalContextHolder: ReactNode = null;

/**
 * 设置全局 modal 实例
 * 在应用的根组件中调用
 */
export function setGlobalModal(modal: ReturnType<typeof Modal.useModal>[0], contextHolder: ReactNode) {
  globalModalInstance = modal;
  globalContextHolder = contextHolder;
}

/**
 * 获取全局 modal 实例
 */
export function getGlobalModal(): ReturnType<typeof Modal.useModal>[0] | null {
  return globalModalInstance;
}

/**
 * 获取全局 contextHolder
 */
export function getGlobalContextHolder(): ReactNode {
  return globalContextHolder;
}

/**
 * 显示错误弹窗（全局）
 */
export function showGlobalError(config: ModalFuncProps) {
  if (globalModalInstance && typeof globalModalInstance.error === 'function') {
    globalModalInstance.error(config);
  } else {
    // 兜底：使用静态方法（可能有 CSS 变量问题，但保证能显示）
    Modal.error(config);
  }
}

/**
 * 显示信息弹窗（全局）
 */
export function showGlobalInfo(config: ModalFuncProps) {
  if (globalModalInstance && typeof globalModalInstance.info === 'function') {
    globalModalInstance.info(config);
  } else {
    Modal.info(config);
  }
}

/**
 * 显示确认弹窗（全局）
 */
export function showGlobalConfirm(config: ModalFuncProps) {
  if (globalModalInstance && typeof globalModalInstance.confirm === 'function') {
    globalModalInstance.confirm(config);
  } else {
    Modal.confirm(config);
  }
}
